import apiClient from "./Api";
/**
 * Obtiene la lista de proyectos. Puede filtrar por título, tags, etc.
 * @param {Object} filters - Objeto con posibles filtros: { title, tags, tags_uuid_list, aoi_name, aoi_uuid_list, language }
 * @returns {Promise} Array de proyectos
 */
export const getProjects = async (filters = {}) => {
  // Endpoint swagger: GET /core/projects
  // Se incluyen los filtros como query params
  const response = await apiClient.get("/core/projects", {
    params: {
      title: filters.title,
      tags: filters.tags,
      tags_uuid_list: filters.tags_uuid_list,
      aoi_name: filters.aoi_name,
      aoi_uuid_list: filters.aoi_uuid_list,
      language: filters.language,
    },
  });
  return response.data;
};

export const getProjectByUUID = async (project_uuid) => {
  // Endpoint swagger: GET /core/projects
  // Se incluyen los filtros como query params
  const response = await apiClient.get(`/core/project/${project_uuid}`);
  return response.data;
};
